import { PlanCardProps } from '@/components/PlanCards';
import { boolDesc } from '@/types/wegengage';
import { calculateDuration } from '@/components/PlanCards/PlanCard';
import { ValidityType } from './plancardsUtils';
import { ServiceSlot } from '@/components/ChooseSlot';

class WebEngageUtils {
  static getTiersVisible(amcPlans?: PlanCardProps[]): string {
    const tiers = ['value', 'silver', 'gold', 'platinum'];
    const visibleTiers: string[] = [];
    if (!amcPlans) return '';
    tiers.forEach((tier) => {
      if (
        amcPlans.find((plan) => {
          return plan.tier.toLowerCase() === tier && plan.show;
        })
      ) {
        visibleTiers.push(tier);
      }
    });
    return visibleTiers.length ? visibleTiers.join(' + ') : '';
  }

  static returnBoolString(flag: boolean) {
    return flag ? 'Yes' : 'No';
  }

  // static isPlanRecommended(webData: PlanCardProps[], currentPlanTier: string) {
  //   if (!webData) return false;
  //   let isRecommended = false;
  //   webData.forEach((plan) => {
  //     if (plan.tier === currentPlanTier) {
  //       isRecommended = true;
  //     }
  //   });
  //   return isRecommended;
  // }

  static getPlanDuration(validity: ValidityType) {
    if (!validity) return '';
    const duration = calculateDuration(validity);
    return duration.toLowerCase() === 'year' ? '1 Year' : duration;
  }

  static createSlotStr(slotData: ServiceSlot[]) {
    const slotArr: Array<String> = [];
    slotData
      .filter((el) => el.available)
      .forEach((item) => {
        slotArr.push(`${item.slot.startTime.getHours()}-${item.slot.endTime.getHours()}`);
      });
    return slotArr.join(', ');
  }

  static slotDiff(slotData: ServiceSlot[]) {
    return slotData.filter((el) => el.available)?.[0]?.slot?.startTime?.getTime() - Date?.now();
  }

  static calculatePlanDuration(startingDate: string, endingDate: string) {
    let startDate = new Date(new Date(startingDate).toISOString().substr(0, 10));
    let endDate = new Date(endingDate);
    if (startDate > endDate) {
      const swap = startDate;
      startDate = endDate;
      endDate = swap;
    }
    const startYear = startDate.getFullYear();
    const february =
      (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0 ? 29 : 28;
    const daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    let yearDiff = endDate.getFullYear() - startYear;
    let monthDiff = endDate.getMonth() - startDate.getMonth();
    if (monthDiff < 0) {
      yearDiff--;
      monthDiff += 12;
    }
    let dayDiff = endDate.getDate() - startDate.getDate();
    if (dayDiff < 0) {
      if (monthDiff > 0) {
        monthDiff--;
      } else {
        yearDiff--;
        monthDiff = 11;
      }
      dayDiff += daysInMonth[startDate.getMonth()];
    }

    if (yearDiff > 0) {
      return WebEngageUtils.getPlanDuration({ duration: yearDiff, unit: 'Y' });
    } else {
      return calculateDuration({ duration: monthDiff, unit: 'M' });
    }
  }

  static filterAvailed = (arr: any) => {
    return arr.filter((el: any) => el.isAvailed);
  };

  static generateTrackingData = (serviceReqStatusData: any) => {
    const { statuses = [] } = serviceReqStatusData || '';
    const { type = '' } = statuses[statuses.length - 1] || '';
    const _status: boolDesc = type == 'SERVICE_COMPLETED' ? 'No' : 'Yes';
    const _serviceSlot = [
      {
        slot: {
          startTime: new Date(serviceReqStatusData?.slot?.start_time),
          endTime: new Date(serviceReqStatusData?.slot?.end_time),
        },
        workerCodes: [],
        available: true,
        slotDuration: 1,
      },
    ];
    return {
      service_request_status: type,
      service_request_open: _status,
      service_request_number: serviceReqStatusData?.service_request_number,
      service_type: serviceReqStatusData?.job_type,
      defect_selected: serviceReqStatusData?.defect_type,
      date_selected: serviceReqStatusData?.slot?.start_time,
      time_slot_selected: WebEngageUtils.createSlotStr(_serviceSlot),
    };
  };

  static stringUtil = (value: any) => {
    if (value === null || value === undefined) {
      return '';
    }
    return value;
  };
}

export default WebEngageUtils;
